import React from 'react'
import {Line} from 'react-chartjs-2'
import PropTypes from 'prop-types'
import moment from 'moment'
import { labelsFormatter } from 'utils/formatters'
import Ad from 'components/Ad'

const LineChartNormal = ({ history, mode, filter, ...props }) => {

	const mainData = history.data
		.filter(rate => ( mode === 'monetary' ? rate.to_currency_id === props.currency : rate.to_crypto_currency_id === props.currency ) && moment(rate.date) >= moment(props.fromDate))
		.map(rate => ({
			label: labelsFormatter(rate.date, filter),
			price: parseFloat(rate.conversion_value)
		}))

	const colorEbony = '#282844'
	const colorEbonyTransparent = 'rgba(40, 40, 68, .7)'
	const colorCornFlower = '#3180ff'
	const colorCornFlowerTransparent = 'rgba(49, 128, 255, .5)'
	const mainColor = (mode === 'monetary') ? colorEbony : colorCornFlower
	const mainColorTransparent = (mode === 'monetary') ? colorEbonyTransparent : colorCornFlowerTransparent

	const chartConfig = {
		data: {
			labels: mainData.map(rate => rate.label),
			datasets: [
				{
					label: 'Курс',
					backgroundColor: mainColorTransparent,
					pointBackgroundColor: '#fff',
					pointHoverBackgroundColor: '#fff',
					borderColor: mainColor,
					pointBorderColor: mainColor,
					pointHoverBorderColor: mainColor,
					pointBorderWidth: 3,
					pointRadius: 4,
					pointHoverRadius: 4,
					data: mainData.map(rate => rate.price),
				}
			]
		},
		styles: {
			graphContainer: {
				borderBottom: '1px solid #ecf3fd',
				padding: '0 0 30px'
			}
		}
	}

	return <div style={chartConfig.styles.graphContainer}>
		<div className='o-layout'>
			<div className='o-layout__item u-1/1 u-3/4@tablet'>
				<Line data={chartConfig.data} />
				<p className='u-margin u-text--small'>* Всички данни са осреднени по ден/седмица/месец/година за съответния период.</p>
				{ filter === 'fiveYears' && mainData.length < 6 ? <p className='u-margin u-text--small'>** Липсват по-ранни данни за тази валута.</p> : null }
			</div>
			<div className='o-layout__item u-1/1 u-1/4@tablet'>
				{/*AdSense*/}
				<Ad
					slot='7962002884'
					style={{ display: 'block', height: 400, width: '100%' }}
				/>
			</div>
		</div>
	</div>
}

LineChartNormal.propTypes = {
	history: PropTypes.shape({
		data: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.number,
			to_currency_id: PropTypes.number,
			//conversion_value: PropTypes.number,
			//inverse_conversion_value: PropTypes.number,
			name: PropTypes.string,
			abbreviature: PropTypes.string,
			flag: PropTypes.string,
			quantity: PropTypes.number,
			date: PropTypes.string
		})),
		isFetching: PropTypes.bool
	}),
	mode: PropTypes.string,
	filter: PropTypes.string
}

export default LineChartNormal
